import { React, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { motion } from "framer-motion";
import { Col, ProgressBar, Row } from "react-bootstrap";

export const SkillsShowcase = (props) => {
	const [index, setIndex] = useState(0);

	const handleSelect = (selectedIndex, e) => {
		setIndex(selectedIndex);
	};

	return (
		<Carousel
			className="mt-5 carousel text-center text-light"
			activeIndex={index}
			onSelect={handleSelect}
		>
			{props.items.map((item, i) => (
				<Carousel.Item
					className="d-flex-column align-items-center"
					key={i}
				>
					<motion.div
						className="skillIconItem"
						whileHover={{
							scale: 1.1,
							transition: { duration: 0.5 },
						}}
					>
						{item.icon}
					</motion.div>
					<h2 className="mt-2 mb-2">{item.label}</h2>
					<Row>
						<Col
							className={
								item.level >= 80
									? "bg-dark text-primary rounded m-auto"
									: item.level >= 40
									? "bg-dark text-warning rounded m-auto"
									: "bg-dark text-danger rounded m-auto"
							}
							xs={4}
						>
							{item.level >= 80
								? "Proficient"
								: item.level >= 40
								? "Learning"
								: "Beginner"}
						</Col>
					</Row>
					<Row className="m-auto mt-3">
						{/* <Col className="d-none d-md-block " xs={4}>
							{item.level >= 80
								? "Proficient"
								: item.level >= 40
								? "Learning"
								: "Beginner"}
						</Col> */}
						<Col className="m-auto" xs={7}>
							<ProgressBar
								className="m-auto pbar"
								animated
								striped
								now={item.level}
								variant={
									item.level >= 80
										? "primary"
										: item.level >= 40
										? "warning"
										: "danger"
								}
								visuallyHidden
							/>
						</Col>
					</Row>
				</Carousel.Item>
			))}
		</Carousel>
	);
};
